<div class="modal-body content width-400">
	<div class="layout-auto-1-auto">
		<h5 class="modal-header">{{data.headerText}}</h5>
		<div>
			<exg-input [(ngModel)]="name"
			           [required]="true"
			           [caption]="data.caption"
			           name="name">
      </exg-input>
		</div>

		<div class="spawn-modal-actions">
			<button class="md-btn"
              [disabled]="!valid()"
              (click)="save()">
        {{data.buttonText}}
      </button>
			<button class="md-btn"
              (click)="cancel()">
        {{getGlobal('Cancel')}}
      </button>
		</div>
	</div>
</div>
